    <template>
    <div class="fileModal">
        <el-dialog class="dialogBox" :title="dialogType" :visible.sync="DialogVisible" width="50%" :before-close='beforeClose'  center>
            
               
            
            <el-form :model="form"  ref='form' class="flex ml20 mr20 c314" :rules="rules" >
                <el-row >
                <el-col :span='11'>
                    <el-form-item  :label="$t('manipulation.devName')" prop="projectName" :label-width="formLabelWidth">
                            <el-input v-model="form.projectName" autocomplete="off" :disabled="disabled"></el-input>
                    </el-form-item>
                </el-col>
                 <!-- <el-col :span='11'>
                    <el-form-item  label="安装工地" prop="installSite" :label-width="formLabelWidth">
                            <el-input v-model="form.installSite" autocomplete="off" :disabled="disabled"></el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :span='11'>
                    <el-form-item  :label="$t('fileManage.timeSetting')" :label-width="formLabelWidth">
                            <el-date-picker v-model="form.installDate" value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd" autocomplete="off" type="date" :placeholder="$t('alarmData.choiceDate')" style="width:100%"
                            :disabled="disabled">
                            </el-date-picker>
                        </el-form-item>
                </el-col>
                <!-- <el-col :span='11'>
                     <el-form-item class="_formItem" label="状态" :label-width="formLabelWidth" >
                            <el-select v-model="form.status" placeholder="请选择"  :disabled="disabled" style="width:100%">
                                    <el-option
                                    v-for="(item,index) in typeList"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.value">
                                    </el-option>
                            </el-select>
                        </el-form-item>
                </el-col> -->
                <el-col :span='11'>
                     <el-form-item class="_formItem" :label="$t('fileManage.province')" prop='province' :label-width="formLabelWidth">
                            <el-input v-model="form.province" autocomplete="off" :disabled="disabled"></el-input>
                        </el-form-item>
                </el-col>
                <el-col :span='11'>
                    <el-form-item class="_formItem" :label="$t('fileManage.city')"  prop='city' :label-width="formLabelWidth">
                            <el-input v-model="form.city" autocomplete="off" :disabled="disabled"></el-input>
                        </el-form-item>
                </el-col>
                <el-col :span='11'>
                    <el-form-item class="_formItem" :label="$t('fileManage.longitude')" prop='location.lon' :rules="{ required: true, message: `${$t('fileManage.inputLongitude')}`, trigger: 'blur' }" :label-width="formLabelWidth">
                            <el-input v-model="form.location.lon" v-if="DialogVisible"  :disabled="disabledLocation">
                            </el-input>
                        </el-form-item>
                </el-col>
                <el-col :span='11'>
                    <el-form-item class="_formItem" :label="$t('fileManage.latitude')" prop='location.lat' :rules=" { required: true, message: `${$t('fileManage.inputLatitude')}`, trigger: 'blur' }" :label-width="formLabelWidth">
                            <el-input v-model="form.location.lat" v-if="DialogVisible" :disabled="disabledLocation">
                            </el-input>
                        </el-form-item>
                </el-col>
                <el-col :span='22'>
                    <el-form-item class="_formItem" :label="$t('manipulation.installAddress')" :label-width="formLabelWidth">
                            <el-input v-model="form.address" autocomplete="off" :disabled="disabled"></el-input>
                        </el-form-item>
                </el-col>

                <el-col :span='11'>
                    <el-form-item class="_formItem" :label="$t('realdetile.contUnit')" :label-width="formLabelWidth">
                            <el-input v-model="form.organization" autocomplete="off" :disabled="disabled"></el-input>
                        </el-form-item>
                </el-col>
                <el-col :span='11'>
                    <el-form-item class="_formItem" :label="$t('fileManage.contact')" :label-width="formLabelWidth">
                            <el-input v-model="form.linkman" autocomplete="off" :disabled="disabled"></el-input>
                        </el-form-item>
                </el-col>

                <el-col :span='11'>
                    <el-form-item class="_formItem" :label="$t('fileManage.installer')" :label-width="formLabelWidth">
                            <el-input v-model="form.dutyPerson" autocomplete="off" :disabled="disabled"></el-input>
                        </el-form-item>
                </el-col>
                <el-col :span='11'>
                    <el-form-item class="_formItem" :label="$t('fileManage.contactPhone')" prop="phone" :label-width="formLabelWidth">
                            <el-input v-model="form.phone" type="number" autocomplete="off" :disabled="disabled"></el-input>
                        </el-form-item>
                </el-col>
                
                </el-row>
            
                <div class="item_ flex between mt10" style="height: 50px;" v-if="!disabled">
                <el-form-item class="_formItem txtl">
                    <!-- <span style="font-size:12px;color:red;">（选取点后，经度、纬度、省份、城市会被自动添上）</span> -->
                    <el-button-group>
                    <!-- 1、地图上选点(chose) 2、关键词搜索(search) -->
                    <el-button size="small" :type="pointChoseType=='chose'?'primary':'info'" @click="mapselectpoint">{{$t('fileInfo.mapPoint')}}
                    </el-button>
                    <el-button size="small" :type="pointChoseType=='search'?'primary':'info'" @click="mapkeyword">{{$t('fileInfo.keySearch')}}
                    </el-button>
                    </el-button-group>
                </el-form-item>
                <el-form-item  v-show="pointChoseType == 'search'" :label="$t('fileInfo.place')"
                    :label-width="formLabelWidth">
                    <el-input v-model="mapsearch" class="searchStation" :placeholder="$t('fileInfo.pleSearchPlace')"
                    @keyup.enter.native="mapKeyWord()">
                    <el-button slot="append" icon="el-icon-search" @click="mapKeyWord"></el-button>
                    </el-input>
                </el-form-item>
                </div>
                <div class="item_">
                <!-- 地图 -->
                <div id="StationMap"></div>
                </div>
            </el-form>
            
            <div slot="footer" class="dialog-footer flex row vertical-center" >
                <el-button @click="closedialog" size="small" class="mr40">{{$t('manipulation.cancel')}}</el-button>
                <el-button type="primary" size="small" @click="handleSubmit">{{$t('manipulation.sure')}}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>


import { addproject,putproject } from '@/api/deviceOverview/file';
export default {
    name: 'fileModal',
    props: {
        DialogVisible: {
            type: Boolean,
            default: false
        },
        dialogType: {
            type: String
          
        },
        
    },
    data() {
        return {
            rules: {
                projectName:[
                    { required: true, message: this.$t('userManage.pleInputProName'), trigger: 'blur' }
                ],
                province:[
                     { required: true, message: this.$t('fileManage.inputProvinceName'), trigger: 'blur' }
                ],
                city:[
                     { required: true, message: this.$t('fileManage.inputCityName'), trigger: 'blur' }
                ],
                phone:[
                     { required: true, message: this.$t('fileManage.inputLatitude'), trigger: 'change' },
                    {pattern:/^(?:(?:\+|00)86)?1[3-9]\d{9}$/,message:this.$t('userManage.phoneFault')}
                ],
                // lat:[
                //      { required: true, message: '请输入经度', trigger: 'change' }
                // ],
            },
            form:{
                location: {
                    lat: null,
                    lon: null
                },
                status:''
            },
            pointChoseType: 'chose',
            formLabelWidth:'190px',
            keyWordObj: null,         // 关键词检索变量
            map: null, 
             disabled: false,
             mapsearch:'',
             disabledLocation:'',
             typeList:[
                 {name:this.$t('fileManage.set'),value:'0'},
                 {name:this.$t('fileManage.debug'),value:'1'}
             ]
        };
    },
    created() {
       
    },
    mounted() {
        
    },
    methods: {
        closedialog(){
            this.init()
            this.$emit('closefile');
            
        },
        mapKeyWord(){

        },
       
        getinfo(info){
            let res = JSON.parse(JSON.stringify(info))
            if(res.location){
                res.location = JSON.parse(res.location)
            }
            this.form = res
        },
        // 分页导航
        handleCurrentChange(val) {
            this.param.current = val;
          
        },
        // 提交表单
        handleSubmit() {
             this.$refs['form'].validate((valid) => {
                 console.log(this.form)
                 debugger
                if (valid) {
                    this.form.location = JSON.stringify(this.form.location)
                    if(this.dialogType===this.$t('userManage.newAdd')){
                        
                        addproject(this.form).then(res=>{
                            if(res.data.code===200){
                                this.$message.success(res.data.msg)
                                this.$emit('closefile','0');
                                this.init()
                                console.log(this.form)
                            }
                        })
                    }else{
                        putproject(this.form).then(res=>{
                            if(res.data.code===200){
                                this.$message.success(res.data.msg)
                                this.$emit('closefile','0');
                                this.init()
                            }
                        })
                    }
                }
             })
        
        },
        beforeClose(done) {
           
            this.$emit('closefile');
            this.init()
          
        },
        init(){
             
             this.form={
                 location: {
                    lat: null,
                    lon: null
                },
                status:''}
              
             this.$refs.form.resetFields()
           
        },
        mapinit() {
            // 创建地图实例
            this.map = new BMap.Map('StationMap')
            // 设置中心点和缩放比例
            // this.map.centerAndZoom(new BMap.Point(116.404, 39.915), 11)
            this.prePoint = this.form.location
            if (this.form.location.lon == null || this.form.location.lon == '') {
                this.map.centerAndZoom(this.$t('fileInfo.hangZhou'), 11)
            } else {
                this.map.centerAndZoom(new BMap.Point(this.form.location.lon, this.form.location.lat), 11)
                var point = new BMap.Point(this.form.location.lon, this.form.location.lat);
                var myIcon = new BMap.Icon(require('@/assets/img/map_icon.png'), new BMap.Size(47, 49))
                var marker = new BMap.Marker(point, { icon: myIcon })  // 创建标注
                this.map.addOverlay(marker) // 将标注添加到地图中
            }

            // 修改地图主题样式
            this.map.setMapStyle({
                style: this.currentMayStyle
            })
            // 开启鼠标滚轮缩放
            this.map.enableScrollWheelZoom(true)
            },
            // 选择-地图上选点
            mapselectpoint() {
            // 修改选点方式
            this.pointChoseType = 'chose' // 1、地图上选点(chose) 2、关键词搜索(search)
            // 清除地图
            this.map = null
            // 清除 地点关键词
            this.form.locationKeyWord = '' // 地点关键词
            // 设置地图
            this.$nextTick(function () {

                // 百度地图是必须让它在页面加载完成后显示（生命周期mounted），但是由于element的对话框（el-dialog）是基于v-if这个功能。所以，应该在dom加载完后再初始化地图
                // 地图初始化
                this.mapinit()
                // 添加点击地图监听事件---点击地图后添加标注点
               
                this.map.addEventListener('click', function (e) {
                    // console.log(e)
                    // 清除标注点
                    this.map.clearOverlays()
                    // 添加标注点
                    var point = new BMap.Point(e.point.lng, e.point.lat) // 创建点
                    var myIconOn = new BMap.Icon(require("@/assets/img/map_icon.png"), new BMap.Size(47, 49))
                    var marker = new BMap.Marker(point, { icon: myIconOn })  // 创建标注
                    // var marker = new BMap.Marker(point)  // 创建标注
                    this.map.addOverlay(marker) // 将标注添加到地图中
                    // 修改form表单内容
                    // 设备坐标
                    this.form.location = {
                    'lat': e.point.lat.toFixed(6),
                    'lon': e.point.lng.toFixed(6)
                    }
                
                    var geoc = new BMap.Geocoder() // 用于获取用户的地址解析
                    // 地址解析
                    geoc.getLocation(e.point, function (rs) {
                        var addComp = rs.addressComponents
                        // 设备所在省份
                        this.form.province = addComp.province
                        // 设备所在城市
                        this.form.city = addComp.city
                        this.$forceUpdate()
                    }.bind(this))
                }.bind(this))
                
            }.bind(this))
            },
            // 选择-关键词搜索
            mapkeyword() {
            console.log(1)
            // 修改选点方式
            // debugger
            this.pointChoseType = 'search' // 1、地图上选点(chose) 2、关键词搜索(search)
            // 清除地图
            this.map = null
            // 清除 地点关键词
            this.form.locationKeyWord = '' // 地点关键词
            // 设置地图
            this.$nextTick(function () {
                // 百度地图是必须让它在页面加载完成后显示（生命周期mounted），但是由于element的对话框（el-dialog）是基于v-if这个功能。所以，应该在dom加载完后再初始化地图
                // 地图初始化
                this.mapinit()

                var _this = this
                // 关键词检索
                var gjcOptions = {
                // 结果呈现设置
                renderOptions: { map: this.map },
                // // 标注添加完成后的回调函数
                // onMarkersSet: function () {
                //   console.log('onMarkersSet')
                // },
                // 标注气泡内容创建后的回调函数---点击不同气泡会触发
                onInfoHtmlSet: function (res) {
                
                    // 修改form表单内容
                    // 设备坐标
                    _this.form.location = {
                    'lat': res.point.lat.toFixed(6),
                    'lon': res.point.lng.toFixed(6)
                    }
                    // 设备所在省份
                    _this.form.province = res.province
                    // 设备所在城市
                    _this.form.city = res.city
                }

                // // 结果列表添加完成后的回调函数
                // onResultsHtmlSet: function () {
                //   console.log('onResultsHtmlSet')
                // },
                // // 检索完成后的回调函数
                // onSearchComplete: function (results) {
                //   console.log(results)
                // }
                }
                // console.log(gjcOptions)
                this.keyWordObj = new BMap.LocalSearch(this.map, gjcOptions) // 用于位置检索、周边检索和范围检索。
                var allOverlay = this.map.getOverlays();
                console.log(allOverlay)
                // this.keyWordObj.search("景点")
                // 添加点击地图监听事件---点击地图后添加标注点
                this.map.addEventListener('click', function (e) {
                // console.log(e)
                // console.log(this.prePoint)
                // 清除标注点
                // this.map.clearOverlays(marker)
                var allOverlay = this.map.getOverlays();
                // console.log(allOverlay)
                // console.log(this.prePoint)
                for (var i = 0; i < allOverlay.length; i++) {
                    if (allOverlay[i].point && (allOverlay[i].point.lng == this.prePoint.lon && allOverlay[i].point.lat == this.prePoint.lat)) {
                    this.map.removeOverlay(allOverlay[i]);
                    // return false;
                    }
                }
                this.mapsearch = ''
                // 添加标注点
                var point = new BMap.Point(e.point.lng, e.point.lat) // 创建点
                var myIconOn = new BMap.Icon(require("@/assets/img/map_icon.png"), new BMap.Size(47, 49))
                var marker = new BMap.Marker(point, { icon: myIconOn })  // 创建标注
                // var marker = new BMap.Marker(point)  // 创建标注
                this.map.addOverlay(marker) // 将标注添加到地图中
                // 修改form表单内容
                // 设备坐标
                this.form.location = {
                    'lat': e.point.lat.toFixed(6),
                    'lon': e.point.lng.toFixed(6)
                }
                this.prePoint = {
                    'lat': e.point.lat,
                    'lon': e.point.lng
                }
                var geoc = new BMap.Geocoder() // 用于获取用户的地址解析
                // 地址解析
                geoc.getLocation(e.point, function (rs) {
                    var addComp = rs.addressComponents
                    // 设备所在省份
                    this.form.province = addComp.province
                    // 设备所在城市
                    this.form.city = addComp.city
                }.bind(this))
                }.bind(this))
            }.bind(this))
            },

            // 点击地点的搜索---关键词检索
            mapKeyWord() {
            console.log(2)
            this.keyWordObj.search(this.mapsearch)
            },
            
    }
};
</script>

<style lang="scss" scoped>
.fileModal {
    #StationMap {
        width: 100%;
        height: 300px;
        .BMap_cpyCtrl {
            display: none;
        }
        .anchorBL {
            display: none;
        }
    }
}

</style>
